import { Box } from '@mui/material';
import { DealFrom } from 'components/featured/Deals/components/DealForm';
import { apiDealTypes, DealType, PIPELINE_MAP } from 'model/deals.model';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchDealById } from 'store/slices/dealsSlice';

const DealEdit = () => {
  const { id } = useParams();

  const dispatch = useAppDispatch();
  const { loading, deal } = useAppSelector((state) => state.deals);

  useEffect(() => {
    if (!id) return;

    const fetchDeal = async () => {
      try {
        await dispatch(fetchDealById(id));
      } catch (error) {
        console.error(error);
      }
    };

    fetchDeal();
  }, [dispatch, id]);

  if (loading === 'in-progress') return <>Loading...</>;

  return (
      <Box sx={{ height: 'calc(100vh - 200px)' }}>
        <DealFrom
          pipelineType={PIPELINE_MAP[deal.pipelineType as apiDealTypes] as DealType}
          deal={deal}
          isEdit={true}
        />
      </Box>
  );
};

export default DealEdit;
